import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { allPhotos } from '../../data/photos/allPhotos';

import Header from '../../components/Header';
import ButtonWhatsappChat from '../../components/ButtonWhatsappChat';
import Footer from '../../components/Footer';

import Arrow from '../../assets/images/arrow.svg';
import CloseIcon from '../../assets/images/close-icon-circle.svg';

import './styles.css';

function IndividualPhotos() {
    const { fotoId } = useParams();
    const result = allPhotos.filter((photo) => photo.customUrl === fotoId);
    let parsed = {};
    
    const [modal, setModal] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    result.forEach((item) => {
        for(let i in item) {
            parsed[i] = item[i];
        }
    });

    let lstPhotos = parsed.lstPhotos;

    const handleClick = (index) => {
        setCurrentIndex(index);
        toggleModal();
    }

    const toggleModal = () => {
        setModal(!modal);
    }

    const nextImage = () => {
        const istLastImage = currentIndex === lstPhotos.length - 1 ? true : false;
        const newIndex = istLastImage ? currentIndex : currentIndex + 1;
        setCurrentIndex(newIndex);
    }

    const previousImage = () => {
        const isFirstImage = currentIndex === 0 ? true : false;
        const newIndex = isFirstImage ? currentIndex : currentIndex - 1;
        setCurrentIndex(newIndex);
    }
    
    return(
        <>
            <Header type="black" />
            <ButtonWhatsappChat />

            <main className="individual-photo">
                <div className="container">
                    <div className="main-photo">
                        {result.map((item, index) => (
                            <div key={index}>
                                <div className="pointer-none">
                                    <img src={item.mainPhoto} alt={item.name} />
                                </div>
                                <div>
                                    <p>{item.name}</p>
                                    {item.complementaryText !== '' ? <p>{item.type} | {item.complementaryText}</p> : <p>{item.type}</p>}
                                    <p>{item.location}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="other-photos">
                        {lstPhotos.map((photo, index) => (
                            <div key={index} className="pointer" onClick={() => handleClick(index)}>
                                <img src={photo} alt={`Foto ${index + 1}`} />
                            </div>
                        ))} 
                    </div>


                    {modal && (
                        <div className="modal">
                            <div className="overlay">
                                <div className="modal__content">
                                    {currentIndex !== 0 &&  
                                        <div className="modal-arrows left pointer" onClick={previousImage}>
                                            <img src={Arrow} className="arrow--left" alt="Voltar para a foto anterior" />
                                        </div>
                                    }

                                    <div className="modal-img">
                                        <img src={lstPhotos[currentIndex]} alt={`Foto ${currentIndex + 1}`}></img>
                                    </div>

                                    {currentIndex !== lstPhotos.length - 1 &&  
                                        <div onClick={nextImage} className="modal-arrows right pointer">
                                            <img src={Arrow} alt="Avançar para a próxima foto" className="arrow--right" />
                                        </div>
                                    }

                                    <div className="pointer close-modal-wrapper">
                                        <img src={CloseIcon} className="close-modal" alt="Fechar vídeo" onClick={toggleModal} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </main>

            <Footer />
        </>
    )
}

export default IndividualPhotos;